export var WorkTaskStatus;
(function (WorkTaskStatus) {
    WorkTaskStatus["OPEN"] = "Open";
    WorkTaskStatus["COMPLETED"] = "Completed";
    WorkTaskStatus["DELETED"] = "Deleted";
})(WorkTaskStatus || (WorkTaskStatus = {}));
export var WorkTaskPriority;
(function (WorkTaskPriority) {
    WorkTaskPriority["NOT_SPECIFIED"] = "NotSpecified";
    WorkTaskPriority["LOW"] = "Low";
    WorkTaskPriority["MEDIUM"] = "Medium";
    WorkTaskPriority["HIGH"] = "High";
    WorkTaskPriority["URGENT"] = "Urgent";
})(WorkTaskPriority || (WorkTaskPriority = {}));
//# sourceMappingURL=work-task.interface.js.map